export enum DataDictionaryPlaceholder {
  VersionFileName = 'current-dd-version.json',
  EncryptionKey = 'AES256',
}
